import { getSimplrAccountIdOfSelectedTicket } from 'extractFromState';
import { bigCommerceGetQuery } from 'api/orders/bigCommerce';
import { getShippoInfo } from 'api/orders/shippo';

import { setLoading } from 'actions';
import { setOrders, clearOrders } from './OrdersSearchActions';
import { showExpressError } from 'util/errorPopupUtil';
import { getShippoCarrierNameForBigCommerce, UnsupportedCarrier } from '../../util';
import { setShippoTrackingInfo } from 'actions/searchActions';
import { handleError } from 'services/ErrorService/ErrorService';

export const bigCommerceFindOrders = (searchType, searchQuery) => async (dispatch, getState) => {
  const state = getState();
  const simplrAccountId = getSimplrAccountIdOfSelectedTicket(state);

  const params = {
    simplrAccountId,
    searchType,
    searchQuery,
  };

  try {
    dispatch(clearOrders());
    const responseBody = await bigCommerceGetQuery('/searchOrders', params);
    dispatch(setLoading(false, 'searchPage'));
    dispatch(setOrders(responseBody));
  } catch (err) {
    dispatch(setLoading(false, 'searchPage'));
    if (err.status === 404) {
      return dispatch(setOrders([]));
    }
    if (err.status >= 500) {
      return handleError({ error: err, customMessage: 'Find orders failed', showPopup: true });
    }
    let errorMessage = err.text;
    if (!errorMessage) {
      errorMessage = err.response && err.response.text ? err.response.text : 'Request failed';
    }
    handleError({ error: err, customMessage: errorMessage, showPopup: true });
  }
};

export const bigCommerceDecisionTreeSelectOrder = (order) => async (dispatch) => {
  const { shipment_items } = order;

  if (Array.isArray(shipment_items)) {
    await Promise.all(
      shipment_items.map(async (item) => {
        try {
          const { tracking_number, shipping_provider, tracking_carrier } = item;

          if (!tracking_number) {
            return;
          }

          const shippingCarrierName = getShippoCarrierNameForBigCommerce(shipping_provider || tracking_carrier);
          const trackingNumber = tracking_number.trim();
          const shippoInfo = await getShippoInfo(shippingCarrierName, trackingNumber);

          if (item.tracking_link) {
            shippoInfo.tracking_link = item.tracking_link;
          }

          dispatch(setShippoTrackingInfo(item.id, shippoInfo));
        } catch (error) {
          // if unsuported carrier shipping data will be extracted from the item level
          if (!(error instanceof UnsupportedCarrier)) {
            showExpressError(error, 'Error fetching shipping info for this order');
          }

          return null;
        }
      })
    );
  }

  return order;
};
